export default function Social() {
  return (
    <section id="social">
      <div className="btn-facebook">
        <a
          href="https://www.facebook.com/afroditamodelstudio"
          target="_blank" rel="noreferrer noopener"
        >
          <img src="/img/facebook.png" alt="Afrodita Models en Facebook" width="123" height="122" loading="lazy" />
        </a>
      </div>
      <div className="btn-twitter">
        <a
          href="https://x.com/afroditamodels"
          target="_blank" rel="noreferrer noopener"
        >
          <img src="/img/twitter.png" alt="Afrodita Models en X (Twitter)" width="119" height="119" loading="lazy" />
        </a>
      </div>
      <div className="btn-instagram">
        <a
          href="https://www.instagram.com/afroditamodelsoficial/"
          target="_blank" rel="noreferrer noopener"
        >
          <img src="/img/instagram.png" alt="Afrodita Models en Instagram" width="120" height="119" loading="lazy" />
        </a>
      </div>
      <div className="btn-whatsapp">
        <a
          href={/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)?'https://api.whatsapp.com/send/?phone=%2B573226707089&text&type=phone_number&app_absent=0':'https://wa.me/573226707089'}
          target="_blank" rel="noreferrer noopener"
        >
          <img src="/img/whatsapp.png" alt="Escribir a Afrodita Models por WhatsApp" width="118" height="118" loading="lazy" />
        </a>
      </div>
    </section>
  );
}
